export class PrimeNgConfig {
  static SortFieldSubmittedOn = "submittedOn";
  static SortFieldCreatedOn = "createdOn";

  static AutoCompleteMinLength = 3;
  static AutoCompletePlaceholder = "Type 3 chars";
  static AutoCompleteEmptyMessage = "No result found";

  static CalendarPlaceholder = "Select...";
  static DropdownPlaceholder = "Select...";
  static StartDatePlaceHolder = "Start Date..";
  static EndDatePlaceHolder = "End Date..";
  static AddressPlaceholder = "Select Address..";
  static TextPlaceholder = "Enter text..";

  static LongDropdownName = {'max-width': '240px'};
  static OverlayStyle40 = {'width': '400px'};
  static DialogStyle40 = {'width': '40vw', 'max-width': '600px'};
  static DialogStyle50 = {'width': '50vw', 'max-width': '700px'};
  static DialogStyle65 = {'width': '65vw', 'max-width': '900px'};
  static DialogStyle80 = {'width': '80vw', 'max-width': '1000px'};
  static DialogStyle90 = {'width': '90vw', 'max-width': '1200px'};

  static TableFilterPlaceholder = "Table Filter";
  static TableRows: number = 10;
  static MaxTableRows: number = 200;
  static TableDesSortOrder = -1;
  static TableAscSortOrder = 1;
  static TableSingleSelection = "single";
  static TableRowsPerPage = [10, 25, 50, 100, 200];

  static SmallTableRows = 5;
  static SmallTableRowsPerPage = [5, 10, 25, 50];

  static LargeTableRows = 25;
  static LargeTableRowsPerPage = [25,50,100];

}
